/* eslint-disable no-console */
import React, {useEffect} from 'react';

import PageContent from '../../components/PageContent/PageContent';
import country from '../../services/modules/JSON/country';

import GetStarted from './Components/GetStarted';
import HeaderComponent from './Components/HeaderComponent';
import KnowledgeBase from './Components/KnowledgeBase';
import MyOrganization from './Components/MyOrganization';
import ProductSection from './Components/ProductSection';

const HomeScreen: React.FC<{
  setShowTour: React.Dispatch<React.SetStateAction<boolean>>;
  setProduct: React.Dispatch<React.SetStateAction<string>>;
  setOpenKeys: React.Dispatch<React.SetStateAction<string[]>>;
}> = ({setProduct, setShowTour, setOpenKeys}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    Promise.all([country()])
      .then(() => {})
      .catch(() => {});
  }, []);

  return (
    <PageContent>
      <HeaderComponent setShowTour={setShowTour} />
      <GetStarted setOpenKeys={setOpenKeys} />
      <MyOrganization setOpenKeys={setOpenKeys} />
      <ProductSection setProduct={setProduct} setOpenKeys={setOpenKeys} />
      <KnowledgeBase />
    </PageContent>
  );
};

export default HomeScreen;
